import { useContext, useEffect, useState } from "react";
import DocumentsTable from "../../../components/DocumentsSettings/DocumentsTable/DocumentsTable";
import SearchBar from "../../../components/DocumentsSettings/SearchBar/SearchBar";
import Title from "../../../components/DocumentsSettings/Title/Title";
import Icon from "../../../components/Icon/Icon";
import styles from "./DocumentExport.module.css";
import { Link, useLocation } from "react-router-dom";
import Pagination from "../../../components/DocumentsSettings/DocumentsTable/Pagination/Pagination";
import type {
  IGetAllTemplatesParams,
  IGetAllTemplatesResponse,
} from "../../../shared/types/templates.types";
import api from "../../../api/api";
import ExportModal from "../../../components/ExportModal/ExportModal";
import { LoaderContext } from "../../../shared/Contexts/Loader/LoaderContext";

const DocumentExport = () => {
  const { isLoading } = useContext(LoaderContext);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [filter, setFilter] = useState<string>("");
  const [currentPage, setCurrentPage] = useState(1);

  const [isExportModalOpen, setIsExportModalOpen] = useState(false);

  const location = useLocation();
  const [templatesResponse, setTemplatesResponse] =
    useState<IGetAllTemplatesResponse | null>(null);

  const handleFetchTemplates = async (params: IGetAllTemplatesParams) => {
    try {
      const data = await api.TemplategetAllTemplates(params);
      setTemplatesResponse(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    console.log(selectedIds);
  }, [selectedIds]);

  useEffect(() => {
    handleFetchTemplates({
      limit: 8,
      page: currentPage,
      search: filter,
    });
  }, [currentPage, filter]);

  const handleCheckboxChange = (id: string): void => {
    if (selectedIds.includes(id)) {
      const newIds = selectedIds.filter((itemId) => itemId !== id);
      setSelectedIds(newIds);
    } else {
      const newIds = [...selectedIds, id];
      setSelectedIds(newIds);
    }
  };

  const handleCheckboxSelectAll = (): void => {
    if (templatesResponse?.total === 0 || templatesResponse === null) return;
    const allVisibleIds = templatesResponse.data.map((doc) => doc.id);
    const areAllSelected = allVisibleIds.every((id) =>
      selectedIds.includes(id)
    );

    if (areAllSelected) {
      setSelectedIds((prev) =>
        prev.filter((id) => !allVisibleIds.includes(id))
      );
    } else {
      const newIds = [...selectedIds, ...allVisibleIds];
      setSelectedIds(newIds);
    }
  };

  const titles = ["Tipo de Documento", "Escaneados", "Fecha Ultimo Cambio"];

  const filteredRows = templatesResponse?.data.map((doc) => {
    const date = new Date(doc.updatedAt);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);

    const dateForTable = `${day} / ${month} / ${year}`;

    return {
      id: doc.id,
      properties: [doc.name, doc.countScanned, dateForTable],
    };
  });

  return (
    <div className={styles.container}>
      <Title title="Descarga de Documentos" className={styles.title} />
      <p className={styles.description}>
        Se descargaran ficheros individuales por cada tipo de documento
        seleccionado, estos ficheros tendran incluidoasla proppiedades asignadas
        a cada documentos
      </p>
      <div className={styles.actionsContainer}>
        <SearchBar handleSearch={setFilter} placeholder="Buscar documento" />
        <div className={styles.buttonsContainer}>
          <Link
            to="/file-explorer"
            className={styles.fileExplorerButton}
            state={{ from: location.pathname }}
          >
            <span>Ver documentos</span>{" "}
            <Icon name="documents-library" size={20} />
          </Link>
          <button
            className={styles.exportButton}
            disabled={!templatesResponse?.total}
            onClick={() => {
              setIsExportModalOpen(true);
            }}
          >
            <span>Exportar Datos</span> <Icon name="export" size={20} />
          </button>
        </div>
      </div>
      {templatesResponse?.total ? (
        <>
          {" "}
          <div className={styles.exportTableContainer}>
            <DocumentsTable
              titles={titles}
              documents={filteredRows}
              selectedIds={selectedIds}
              handleCheckboxChange={handleCheckboxChange}
              handleCheckboxSelectAll={handleCheckboxSelectAll}
            />
            <Pagination
              totalPages={templatesResponse.totalPages}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
            />
          </div>
        </>
      ) : (
        !isLoading && <>Datos no encontrados {":("}</>
      )}
      <ExportModal
        selectedIds={selectedIds}
        isOpen={isExportModalOpen}
        onRequestClose={() => {
          setIsExportModalOpen(false);
          setSelectedIds([]);
        }}
      />
    </div>
  );
};

export default DocumentExport;
